import React, { useEffect, useState } from "react";
import ReadersMeta from "../metas/readers";
import { Link } from "react-router-dom";
import "../assets/css/blog.css";
import { databaseKey } from "../components/common/database_key";
import { fetchBlogData } from "../components/readers/fetch_blog_data";

const Readers = () => {
  const [blogData, setBlogData] = useState();
  const collectionName = databaseKey();

  useEffect(() => {
    const fetchReadersBlogData = async () => {
      const data = await fetchBlogData(`${collectionName}/readers/`);
      setBlogData(data);
    };

    fetchReadersBlogData();
  }, [collectionName]);

  return (
    <>
      <ReadersMeta />
      <div className="breadcrumbs" data-aos="fade-in">
        <div className="container">
          <h2>Readers</h2>
          <p>
            Embark on a journey to boost your math skills! Explore blogs to
            enhance your mental math abilities and unlock new levels of
            calculation speed.
          </p>
        </div>
      </div>
      <div className="blog-container">
        <div className="container">
          {blogData ? (
            <div className="row">
              {blogData.map((blog) => (
                <div key={blog.id} className="card">
                  <Link to={`/readers/${blog.id}`} className="link-style">
                    <img
                      src={blog.image}
                      className="card-img-top"
                      alt={blog.title}
                    />
                    <div className="card-body">
                      <p className="card-title">
                        <strong>{blog.title}</strong>
                      </p>
                      {blog.count && blog.count > 1 && (
                        <p className="blog-count">{`${blog.count} - Blogs`}</p>
                      )}
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          ) : (
            <>
              <h1 style={{ display: "flex", justifyContent: "center" }}>
                Loading...
              </h1>{" "}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default Readers;
